"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRegistedRequest = void 0;
var IsRegistedRequest = /** @class */ (function () {
    function IsRegistedRequest() {
    }
    return IsRegistedRequest;
}());
exports.IsRegistedRequest = IsRegistedRequest;
;
//# sourceMappingURL=isRegisted.request.js.map